/**
 * 확인(완료) 포인트를 기준으로 지연확인/예외 포인트를 백분율로 계산합니다.
 * @param confirmedPoints 확인 상태일 때 지급 포인트
 * @param percent 0–100 백분율 (지연확인/예외 설정값)
 * @returns 반올림된 정수 포인트
 */
export function getPointsByConfirmedPercent(confirmedPoints: number, percent: number): number {
  return Math.round(confirmedPoints * (percent || 0) / 100);
}
